@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (useMobileView) {
  <div>
    <div class="mob-toolbar">
      <div class="mob-toolbar-inner">
        <div class="mob-search-wrap">
          <span class="p-input-icon-left mob-search-input-wrap">
            <i class="pi pi-search"></i>
            <input class="mob-search-input" pInputText type="text"
              placeholder="Search bookings"
              [(ngModel)]="searchCriteria"
              (keyup.enter)="getSearchResults()"/>
            </span>
            <button class="mob-search-btn" type="button" (click)="getSearchResults()">
              <i class="pi pi-search"></i>
            </button>
          </div>
          <div class="mob-date-nav">
            <button pButton pTooltip="Previous day"
              class="p-button decrementButton mob-nav-btn"
              (click)="dateChange(-1)">
              <span class="pi pi-angle-left"></span>
            </button>
            <div class="mob-cal-wrap">
              <p-datepicker [selectOtherMonths]="true"
                [(ngModel)]="BookingDate" firstDayOfWeek="1"
                dateFormat="dd/mm/yy"
                (onSelect)="doneDate()" (onChange)="doneDate()">
              </p-datepicker>
            </div>
            <button pButton pTooltip="Next day"
              class="p-button incrementButton mob-nav-btn"
              (click)="dateChange(1)">
              <span class="pi pi-angle-right"></span>
            </button>
          </div>
          <div class="mob-counters">
            <button pButton type="button" pTooltip="Bookings in progress"
              class="p-button-sm p-button-warn mob-counter-btn"
              (click)="showInProgress()">
              <span class="pi pi-clock"></span>
              <span>{{bookingsInProgress}}</span>
            </button>
            <button pButton type="button" pTooltip="Bookings today"
              class="p-button-sm p-button-success mob-counter-btn"
              (click)="unshowInProgress()">
              <span class="pi pi-check-circle"></span>
              <span>{{totalBookingsToday}}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="surface-card shadow-2">
        <p-table [value]="ListBookings"
          sortField="startTime"
          [paginator]="true"
          [rows]="10"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          [rowsPerPageOptions]="[10,25,50]"
          [globalFilterFields]="['name','bookingId','bookingIdHR','packageName']"
          responsiveLayout="scroll"
          styleClass="mob-booking-table">
          <ng-template #header>
            <tr>
              <th class="mob-stripe-th"></th>
              <th pSortableColumn="startTime">Booking</th>
              <th pSortableColumn="total" style="text-align:right">Amount</th>
              <th style="width:48px"></th>
            </tr>
          </ng-template>
          <ng-template #body let-data>
            @if ((!data.inProgress && !inProgress) || (data.inProgress && inProgress)) {
              <tr [ngStyle]="{'background-color': data.disabled ? '#fff1f2' : ((data.allergy != null && data.allergy != '') && !data.inProgress ? '#FFFFB2' : '#ffffff')}"
                [class.mob-data-row]="!data.inProgress || inProgress"
                [class.mob-data-row--inprogress]="data.inProgress && inProgress"
                (click)="editdatanew(data.bookingId)">
                <!-- Coloured status stripe -->
                <td class="mob-status-stripe"
                  [ngStyle]="{'background-color': data.disabled ? '#ef4444' : ((data.allergy != null && data.allergy != '') ? '#d97706' : data.inProgress ? '#f59e0b' : '#94a3b8')}">
                </td>
                <!-- 2-line main cell -->
                <td class="mob-main-cell">
                  <div class="mob-main-line1">
                    <span class="mob-time">{{data.startTime | date:'HH:mm' : 'UTC'}}</span>
                    <span class="mob-name">{{data.name}}</span>
                    <span class="mob-inline-icons">
                      @if (data.publicBooking) {
                        <i   class="pi pi-user              mob-iico"></i>
                      }
                      @if (data.awaitingpayment) {
                        <i class="pi pi-dollar            mob-iico mob-iico--red" pTooltip="Payment link sent"></i>
                      }
                      @if (data.notes) {
                        <i           class="pi pi-exclamation-circle mob-iico mob-iico--red" [pTooltip]="data.notes"></i>
                      }
                      @if (data.disabled) {
                        <i        class="pi pi-ban               mob-iico mob-iico--red"></i>
                      }
                      @if (data.allergy) {
                        <i         class="pi pi-star              mob-iico mob-iico--amber"></i>
                      }
                    </span>
                  </div>
                  <div class="mob-main-line2">
                    <span class="mob-bookingid">{{data.bookingIdHR}}</span>
                    @if (data.packageName) {
                      <span class="mob-pkg">&nbsp;&middot;&nbsp;{{data.packageName}}</span>
                    }
                    @if (data.guests) {
                      <span class="mob-guests">&nbsp;&middot;&nbsp;{{data.guests}} guest{{data.guests != 1 ? 's' : ''}}</span>
                    }
                  </div>
                </td>
                <!-- Stacked money -->
                <td class="mob-money-cell">
                  <div class="mob-total">{{data.total | currency: (data.currency || CurrencySymbol)}}</div>
                  <div [class.mob-os--overdue]="data.outstanding > 0" [class.mob-os--paid]="data.outstanding <= 0">
                    {{data.outstanding | currency: (data.currency || CurrencySymbol)}}
                  </div>
                </td>
                <!-- Row actions -->
                <td class="mob-action-cell" (click)="$event.stopPropagation()">
                  <button pButton type="button"
                    class="p-button-text p-button-plain mob-action-btn"
                    (click)="selectedAction = data; rowActionPanel.toggle($event)" [iconOnly]="true"><span class="p-button-icon pi pi-ellipsis-v" aria-hidden="true"></span></button>
                  </td>
                </tr>
              }
            </ng-template>
          </p-table>
        </div>
        <p-popover #rowActionPanel appendTo="body">
          <ng-template pTemplate>
            <div class="mob-action-list">
              <button pButton type="button" class="p-button-outlined mob-action-item"
                (click)="editdatanew($safeNavigationMigration(selectedAction?.bookingId)); rowActionPanel.hide()"><span class="p-button-icon p-button-icon-left pi pi-pencil" aria-hidden="true"></span><span class="p-button-label">Edit Booking</span></button>
                <button pButton type="button" class="p-button-outlined mob-action-item"
                  (click)="emailConf($safeNavigationMigration(selectedAction?.bookingId)); rowActionPanel.hide()"><span class="p-button-icon p-button-icon-left pi pi-envelope" aria-hidden="true"></span><span class="p-button-label">Send Confirmation</span></button>
                  @if (!selectedAction?.disabled) {
                    <button pButton type="button" class="p-button-outlined p-button-danger mob-action-item"
                      (click)="disableData($safeNavigationMigration(selectedAction?.bookingId)); rowActionPanel.hide()"><span class="p-button-icon p-button-icon-left pi pi-trash" aria-hidden="true"></span><span class="p-button-label">Disable Booking</span></button>
                    }
                    @if (selectedAction?.disabled) {
                      <button pButton type="button" class="p-button-outlined p-button-success mob-action-item"
                        (click)="undisableData($safeNavigationMigration(selectedAction?.bookingId)); rowActionPanel.hide()"><span class="p-button-icon p-button-icon-left pi pi-check" aria-hidden="true"></span><span class="p-button-label">Enable Booking</span></button>
                      }
                    </div>
                  </ng-template>
                </p-popover>
              </div>
            }

            @if (!useMobileView) {
              <div>
                @if (ListBookings && AccessAllowed) {
                  <div class="p-3 flex flex-column flex-auto">
                    <h3 style="margin: 0 0 8px 0;" i18n>Bookings Created: </h3>
                    <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 6px; margin-bottom: 20px;">
                      <button pButton type="button" pTooltip="Previous day" style="height: 50px; width: 53px; flex-shrink: 0;" (click)="dateChange(-1);" class="p-button-sm p-element p-ripple p-button p-component">
                        <span class="pi pi-angle-left"></span>
                      </button>
                      <div style="flex-shrink: 0; width: 180px;">
                        <p-datepicker [selectOtherMonths]="true" [(ngModel)]="BookingDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="doneDate()" (onChange)="doneDate()"></p-datepicker>
                      </div>
                      <button pButton type="button" pTooltip="Next day" style="height: 50px; width: 53px; flex-shrink: 0;" (click)="dateChange(1);" class="p-button-sm p-element p-ripple p-button p-component">
                        <span class="pi pi-angle-right"></span>
                      </button>
                      @if (!inProgress) {
                        <p-togglebutton pTooltip="Show disabled bookings" class="p-component" [(ngModel)]="isDisabled" offIcon="pi pi-eye-slash" onIcon="pi pi-eye" [style]="{'color':'white','background-color':'#EF4444','font-weight':'normal','height':'50px','flex-shrink':'0'}" (click)="toggleDisabled()">
                        </p-togglebutton>
                      }
                      <div style="margin-left: auto; display: flex; align-items: center; gap: 6px; flex-shrink: 0;">
                        <button pTooltip="Bookings in progress" pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-warn p-button p-component" (click)="showInProgress()">
                          <span class="pi pi-clock" style="margin-right:8px; font-size: 16px;"></span>
                          <span style="font-size:17px;">{{bookingsInProgress}}</span>
                        </button>
                        <button pTooltip="Bookings made today" pButton type="button" style="height: 50px;" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="unshowInProgress()">
                          <span class="pi pi-check-circle" style="margin-right:8px; font-size: 16px;"></span>
                          <span style="font-size:17px;">{{totalBookingsToday}}</span>
                        </button>
                      </div>
                    </div>
                    <div class="surface-card p-4 shadow-2 border-round" style="overflow-x: auto;">
                      <p-table  #resourceTable
                        [columns]="cols"
                        [value]="ListBookings" sortField="startTime" [paginator]="true" [rows]="10"
                        [showCurrentPageReport]="true" responsiveLayout="scroll"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        [rowsPerPageOptions]="[10,25,50]"
                        [globalFilterFields]="['name', 'bookingId', 'bookingIdHR', 'packageName']"
                        [(selection)]="selectedItems"
                        responsiveLayout="scroll"
                        [selectionPageOnly]="true"
                        [customSort]="true"
                        (sortFunction)="customSort($event)"
                        >
                        <ng-template #caption>
                          <div class="flex">
                            <button
                              type="button"
                              pButton
                              pRipple
                              (click)="resourceTable.exportCSV()"
                              class="mr-2"
                              pTooltip="Export to CSV"
                              tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-file-excel" aria-hidden="true"></span></button>
                              <!-- &nbsp;
                              <button
                                type="button"
                                pButton
                                pRipple
                                (click)="refreshData()"
                                class="mr-2 p-button-info"
                                pTooltip="Refresh Data"
                                tooltipPosition="bottom" [iconOnly]="true"><span class="p-button-icon pi pi-refresh" aria-hidden="true"></span></button> -->
                              </div>
                            </ng-template>
                            <ng-template #header>
                              <tr>
                                <th width="1%">
                                  &nbsp;
                                </th>
                                <th width="1%">
                                  &nbsp;
                                </th>
                                <th width="1%">
                                  &nbsp;
                                </th>
                                <th pSortableColumn="bookingId" width="8%">Sales ID
                                  <p-sorticon [field]="bookingIdHR"></p-sorticon>
                                </th>
                                <th pSortableColumn="startTime" width="10%">Start Date
                                  <p-sorticon [field]="startTime"></p-sorticon>
                                </th>
                                <th pSortableColumn="startTime" width="3%">Start
                                  <p-sorticon [field]="startTime"></p-sorticon>
                                </th>
                                <th pSortableColumn="name" width="10%">Name
                                  <p-sorticon [field]="name"></p-sorticon>
                                </th>
                                <th pSortableColumn="name" width="18%">Admissions
                                  <p-sorticon [field]="admissions"></p-sorticon>
                                </th>
                                <th pSortableColumn="packageName" width="13%">Package
                                  <p-sorticon [field]="packageName"></p-sorticon>
                                </th>
                                <th pSortableColumn="resourcestring" width="10%">Resource
                                  <p-sorticon field="resourcestring"></p-sorticon>
                                </th>
                                <th pSortableColumn="guests" width="6%">Guests
                                  <p-sorticon [field]="guests"></p-sorticon>
                                </th>
                                <th pSortableColumn="total" width="5%">Total
                                  <p-sorticon [field]="total"></p-sorticon>
                                </th>
                                <th pSortableColumn="outstanding" width="5%">O/S
                                  <p-sorticon [field]="outstanding"></p-sorticon>
                                </th>
                                <th width="15%">
                                  Extras
                                </th>
                                <th width="10%">
                                  Allergy
                                </th>
                                @if (useCounters) {
                                  <th width="5%"></th>
                                }
                              </tr>
                            </ng-template>
                            <ng-template #body let-data>
                              @if (!data.inProgress && !inProgress  && (data.allergy == '' || data.allergy == null)) {
                                <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                                  <td (click)="editdatanew(data.bookingId)" >
                                    @if (data.publicBooking) {
                                      <span class="pi pi-user"></span>
                                    }
                                  </td>
                                  <td (click)="editdatanew(data.bookingId)">
                                    @if (data.notes != '' && data.notes != null) {
                                      <span style="color:red" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                                    }
                                  </td>
                                  <td>
                                    @if (data.awaitingpayment) {
                                      <span style="color:red" class="pi pi-dollar" pTooltip="A payment link has been sent for this booking."></span>
                                    }
                                  </td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.bookingIdHR}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'dd/MM/yy'}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.name}} ({{maskMobile(data.phone)}})</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.admissions}}</td>
                                  <!-- <td (click)="editdatanew(data.bookingId)">{{data.email}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.phone}}</td> -->
                                  <td (click)="editdatanew(data.bookingId)">{{data.packageName}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.resourcestring}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.guests}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                                  @if (data.outstanding <=0) {
                                    <td (click)="editdatanew(data.bookingId)">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                                  }
                                  @if (data.outstanding >0) {
                                    <td (click)="editdatanew(data.bookingId)"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                                  }
                                  <td (click)="editdatanew(data.bookingId)">{{data.extrastext}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.allergy}}</td>
                                </tr>
                              }
                              @if (data.inProgress && inProgress) {
                                <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                                  <td (click)="editdatanew(data.bookingId)" >
                                    @if (data.publicBooking) {
                                      <span class="pi pi-user"></span>
                                    }
                                  </td>
                                  <td (click)="editdatanew(data.bookingId)">
                                    @if (data.notes != '' && data.notes != null) {
                                      <span style="color:red" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                                    }
                                  </td>
                                  <td>
                                    @if (data.awaitingpayment) {
                                      <span style="color:red" class="pi pi-dollar" pTooltip="A payment link has been sent for this booking."></span>
                                    }
                                  </td>
                                  <td style="cursor:not-allowed">{{data.bookingIdHR}}</td>
                                  <td style="cursor:not-allowed">{{data.startTime | date:'dd/MM/yy'}}</td>
                                  <td style="cursor:not-allowed">{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                                  <td style="cursor:not-allowed">{{data.name}} ({{data.phone}})</td>
                                  <td style="cursor:not-allowed">{{data.admissions}}</td>
                                  <td style="cursor:not-allowed">{{data.packageName}}</td>
                                  <td style="cursor:not-allowed">{{data.resourcestring}}</td>
                                  <td style="cursor:not-allowed">{{data.guests}}</td>
                                  <td style="cursor:not-allowed">{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                                  @if (data.outstanding <=0) {
                                    <td style="cursor:not-allowed">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                                  }
                                  @if (data.outstanding >0) {
                                    <td style="cursor:not-allowed"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                                  }
                                  <td style="cursor:not-allowed">{{data.extrastext}}</td>
                                  <td style="cursor:not-allowed">{{data.allergy}}</td>
                                </tr>
                              }
                              @if (!data.inProgress && !inProgress && data.allergy != '' && data.allergy != null) {
                                <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#FFFFB2'}">
                                  <td (click)="editdatanew(data.bookingId)" >
                                    @if (data.publicBooking) {
                                      <span class="pi pi-user"></span>
                                    }
                                  </td>
                                  <td (click)="editdatanew(data.bookingId)">
                                    @if (data.notes != '' && data.notes != null) {
                                      <span style="color:red" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                                    }
                                  </td>
                                  <td>
                                    @if (data.awaitingpayment) {
                                      <span style="color:red" class="pi pi-dollar" pTooltip="A payment link has been sent for this booking."></span>
                                    }
                                  </td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.bookingIdHR}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'dd/MM/yy'}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.name}} ({{data.phone}})</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.admissions}}</td>
                                  <!-- <td (click)="editdatanew(data.bookingId)">{{data.email}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.phone}}</td> -->
                                  <td (click)="editdatanew(data.bookingId)">{{data.packageName}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.resourcestring}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.guests}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                                  @if (data.outstanding <=0) {
                                    <td (click)="editdatanew(data.bookingId)">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                                  }
                                  @if (data.outstanding >0) {
                                    <td (click)="editdatanew(data.bookingId)"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                                  }
                                  <td (click)="editdatanew(data.bookingId)">{{data.extraslist}}</td>
                                  <td (click)="editdatanew(data.bookingId)">{{data.allergy}}</td>
                                </tr>
                              }
                            </ng-template>
                          </p-table>
                          <!-- <button pButton type="button" class="p-button-sm p-element p-ripple p-button p-component" (click)="exportData()" i18>
                          <span class="pi pi-plus"></span> Export this data
                        </button> -->
                      </div>
                    </div>
                  }
                </div>
              }